'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _intersperse = require('linksoft/utils/intersperse');

var _intersperse2 = _interopRequireDefault(_intersperse);

var _linksoftAlbatros = require('linksoft-albatros');

var _actions = require('../../../actions');

var _actions2 = _interopRequireDefault(_actions);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _AuthorLink = require('./AuthorLink');

var _AuthorLink2 = _interopRequireDefault(_AuthorLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('App', 'Common');

function mapStateToProps(state, ownProps) {
    var amount = (0, _linksoftAlbatros.getCartAmountFor)(ownProps, state);
    return (0, _extends3.default)({}, ownProps, {
        amount: amount
    });
}

var mapDispatchToProps = {
    changeAmount: _actions2.default.changeAmount,
    submitChanges: _actions2.default.submitChanges,
    removeItem: _actions2.default.removeItem
};

var CartDetailItem = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$PureComponent) {
    (0, _inherits3.default)(CartDetailItem, _React$PureComponent);

    function CartDetailItem() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, CartDetailItem);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CartDetailItem.__proto__ || (0, _getPrototypeOf2.default)(CartDetailItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleAmountChange = function (e) {
            (0, _linksoftAlbatros.numbersOnly)(e);
            var _this$props = _this.props,
                changeAmount = _this$props.changeAmount,
                productId = _this$props.productId;

            changeAmount({ productId: productId, amount: e.target.value });
        }, _this.handleIncrement = function () {
            _this.props.changeAmount({ productId: _this.props.productId, amount: "" + (_this.props.amount + 1) });
        }, _this.handleDecrement = function () {
            if (_this.props.amount > 0) {
                _this.props.changeAmount({ productId: _this.props.productId, amount: "" + (_this.props.amount - 1) });
            }
        }, _this.handleDelete = function () {
            _this.props.removeItem({ cartItemId: _this.props.cartItemId });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(CartDetailItem, [{
        key: 'renderAvailability',
        value: function renderAvailability() {
            var _props = this.props,
                availability = _props.availability,
                dispatchDate = _props.dispatchDate,
                upcomingDate = _props.upcomingDate,
                amountAvailable = _props.amountAvailable;

            var dispatchDateAsDate = dispatchDate ? new Date(dispatchDate) : null;
            var upcomingDateAsDate = upcomingDate ? new Date(upcomingDate) : null;
            var dispatchText = dispatchDateAsDate ? (0, _linksoftAlbatros.format)(dispatchDateAsDate, 'd') : null;
            var upcomingText = upcomingDateAsDate ? (0, _linksoftAlbatros.format)(upcomingDateAsDate, 'd') : null;
            var productAvailabilityText = (0, _linksoftAlbatros.getAvailabilityText)(availability).replace('{0:d}', upcomingText != null ? upcomingText : dispatchText);
            return availability === _linksoftAlbatros.ProductAvailability.LongerDelivery ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'em',
                    { className: (0, _linksoftAlbatros.getAvailabilityColor)(availability) },
                    _react2.default.createElement('i', { className: 'icon--clock', 'data-toggle': 'tooltip', 'data-placement': 'top', 'data-original-title': productAvailabilityText })
                )
            ) : _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'em',
                    { className: (0, _linksoftAlbatros.getAvailabilityColor)(availability) },
                    productAvailabilityText
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                productName = _props2.productName,
                authors = _props2.authors,
                price = _props2.price,
                amount = _props2.amount,
                url = _props2.url,
                thumbnailUrl = _props2.thumbnailUrl;

            var unitPrice = (price || {}).unitPrice || {};
            var percentageDiscount = unitPrice.percentageDiscount || 0;
            var finalUnitPrice = unitPrice.finalPrice || 0;
            var totalFinalPrice = ((price || {}).totalPrice || {}).finalPrice || 0;

            return _react2.default.createElement(
                'div',
                { className: 'cart__item cart__item--product cart-i' },
                _react2.default.createElement(
                    'div',
                    { className: 'cart-i__first' },
                    _react2.default.createElement(
                        'a',
                        { href: url, className: 'cart-i__cover' },
                        _react2.default.createElement('img', { 'data-src': thumbnailUrl, alt: '' })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'cart-i__infos' },
                        _react2.default.createElement(
                            'a',
                            { href: url, className: 'cart-i__title' },
                            productName
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'cart-i__authors' },
                            (0, _intersperse2.default)((authors || []).map(function (author) {
                                return _react2.default.createElement(_AuthorLink2.default, (0, _extends3.default)({ key: author.id }, author));
                            }), ', ')
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'cart-i__price' },
                            _react2.default.createElement(
                                'span',
                                null,
                                _react2.default.createElement(
                                    'span',
                                    { className: 'cart-i__amount' },
                                    amount
                                ),
                                _react2.default.createElement(
                                    'span',
                                    { className: 'cart-i__price-detail' },
                                    (0, _linksoftAlbatros.formatPrice)(finalUnitPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
                                )
                            ),
                            '\xA0',
                            _react2.default.createElement(
                                'em',
                                { className: 'discounted-price' },
                                Resx.Common.YourDiscountedPrice
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'cart-i__availability hidden-lg-down' },
                        this.renderAvailability()
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'cart-i__amount-edit' },
                    _react2.default.createElement(
                        'div',
                        { className: 'flex-center' },
                        _react2.default.createElement('button', { className: 'btn__square btn__square--minus', onClick: this.handleDecrement }),
                        _react2.default.createElement('input', { type: 'number', min: '0', value: amount, onChange: this.handleAmountChange }),
                        _react2.default.createElement('button', { className: 'btn__square btn__square--plus', onClick: this.handleIncrement })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'hidden-xl-up text-center mt-1' },
                        this.renderAvailability()
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'cart-i__last' },
                    _react2.default.createElement(
                        'div',
                        { className: 'cart-i__summary' },
                        _react2.default.createElement(
                            'span',
                            null,
                            (0, _linksoftAlbatros.formatPrice)(totalFinalPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
                        )
                    ),
                    _react2.default.createElement(
                        'button',
                        { className: 'btn__square cart-i__remove', onClick: this.handleDelete },
                        _react2.default.createElement('i', { className: 'icon--cross' })
                    )
                )
            );
        }
    }]);
    return CartDetailItem;
}(_react2.default.PureComponent)) || _class);
exports.default = CartDetailItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step1/CartDetailItem.js
// module id = 1015
// module chunks = 0